import React, { Component } from 'react';
import tableDragger from 'table-dragger';
import Modal from 'react-responsive-modal';
import swal from 'sweetalert';
import { baseUrl } from '../../Comman/apiEndPoints';
import imageCompression from 'browser-image-compression';
import { withNamespaces } from 'react-i18next';
import InputWithExtra from '../../Comman/components/InputWithExtra';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'; 
import { InputText } from 'primereact/inputtext';
// import { Editor } from "react-draft-wysiwyg";
// import { EditorState } from "draft-js";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var result_arr = [];
class RegionComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // editorState : EditorState.createEmpty(),
            openModal: false,
            image: null,
            isEdit: false,
            ID: 0,
            newRegionData: {
                RegionName: '',
                Description: ''
            }
        }
        this.handleInput = this.handleInput.bind(this);
        this.actionColumn = this.actionColumn.bind(this);
    }

    actionColumn(item) {
        const { t } = this.props;
        return (
            <span>
                <button type="button" className="btn btn-primary edit-carousel"
                    onClick={this.openEditModal.bind(this, item)}>{t('Alarm Setting.Edit')}</button>
                <button type="button" className="btn btn-primary"
                    onClick={this.delete.bind(this, item.ID)}>{t('First_Responder.Delete')}</button>

            </span>
        )
    }
 componentWillReceiveProps(nextProps) {
        // console.log("next",nextProps)
        if (nextProps.RegionDetails.statusCode !== this.props.RegionDetails.statusCode) {
         
            if(nextProps.RegionDetails.statusCode==201){
                this.errornotify(nextProps.RegionDetails.message);
               // this.props.getList();
            }
        }
       
    }
      
    errornotify = (message) => {
        // toast.error(message + "!", {
        //     position: toast.POSITION.TOP_CENTER
        // });
        swal({ text : message, icon : 'error' })

    };
    openModal = () => {
        this.setState({ openModal: true })
    }
    closeModal = () => {
        this.setState({ openModal: false })
        this.setState({ isEdit: false, image: null })
        this.setState({
            newRegionData: {
                RegionName: '',
                Description: ''
            }
        })
    }
    handleInput = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            newRegionData:
                { ...prevState.newRegionData, [name]: value }
        }),)
        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }

    delete(id) {
        const { t } = this.props;
        console.log("data", id);
        swal({
            title: `${t('Region.Delete Region')}`,
            text: `${t('Region.Are you sure you want to delete this region')}?`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    this.props.deleteRegionItem(id);
                    setTimeout(
                        () => this.props.getRegionList(),
                        400
                    );
                } else {
                    swal(`${t('Carousel Setting.Data not deleted')}`);
                }
            });
    }
    add = () => {
        const { t } = this.props;
        if (this.state.newRegionData.RegionName.length > 0) {
            var formData = {
                'ID': 0,
                'RegionName': this.state.newRegionData.RegionName,
                'Description': this.state.newRegionData.Description,
                'CreatedBy': sessionStorage.getItem('SuperAdminUserID')
            }
            this.props.addRegion(formData);
            this.setState({ openModal: false, image: null })
            this.setState({
                newRegionData: {
                    RegionName: '',
                    Description: ''
                }
            })
            setTimeout(
                () => this.props.getRegionList(),
                400
            );

        }
        else {
            swal(`${t('Region.Please Enter Region Name')}`);
        }
    }
    update = () => {
        const { t } = this.props;
        var formData = {
            'ID': this.state.ID,
            'RegionName': this.state.newRegionData.RegionName,
            'Description': this.state.newRegionData.Description,
            'CreatedBy': sessionStorage.getItem('SuperAdminUserID')
        }



        if (this.state.ID > 0 && this.state.newRegionData.RegionName) {
            this.props.updateRegion(formData);
            this.setState({
                isEdit: false,
                image: null,
                ID: 0
            })
            this.setState({
                newRegionData: {
                    RegionName: '',
                    Description: ''
                }
                
            })
             this.setState({ openModal: false, image: null })
            setTimeout(
                () => this.props.getRegionList(),
                400
            );
        }
        else {
            swal(`${t('Region.Please Enter Region Name')}`);
        }
    }
    formatCreatedDate(rowData) {
        if (rowData.CreatedDate != null && rowData.CreatedDate != undefined) {
            if (rowData.CreatedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.CreatedDate.split('T');

                let data = value[1].split(':');
                let sec = data[2].split('.')
                return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
            }
        }
    }
    formatUpdatedDate(rowData) {
        if (rowData.UpdatedDate != null && rowData.UpdatedDate != undefined) {
            if (rowData.UpdatedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.UpdatedDate.split('T');
                let data = value[1].split(':');
                let sec = data[2].split('.')
                return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
            }
        }
    }
    openEditModal = (item) => {
        this.setState({
            isEdit: true,
            ID: item.ID,
            // image : item.PageLogo,
            newRegionData: {
                RegionName: item.RegionName,
                Description: item.Description
            }
        })
    }


    //   onEditorStateChange = (editorState) => {
    //     this.setState({
    //       editorState : editorState
    //     });
    //     console.log("setstate1",this.state);
    //   };
    render() {
        const { t } = this.props;
        var refreshButtonData = <span>
            <button onClick={this.openModal} style={{ outline: 'none', border: 'none' }} type="button" className="notification-badge btn btn-primary">Add<span className="badge bg-secondary"></span></button>

        </span>
        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div className="container carousel-page">

                <div className="progressbar-heading grids-heading">
                    <h2>{t('Region.Regions List')}</h2>
                </div>
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                {refreshButtonData}
                                <div className="w3l_search">

                                    {header}
                                </div>
                                {/* <div className="w3l_search">
                                                <button style={{ marginLeft: '60%',marginTop:'-2rem',outline:'none',border:'none' }} type="button"  class="notification-badge btn btn-primary">Refresh<span class="badge bg-secondary"></span></button>
                
                                                   
                                                </div> */}

                                <div className="devicestable">
                                    <br />

                                    <DataTable
                                        className="table"
                                        value={this.props.RegionDetails.regionList}
                                        //loading={this.props.incomingAlarmList.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}
                                        // rowClassName={this.rowClassName}

                                        emptyMessage={t('Feedback Setting.No records found')}>
                                        <Column field="RegionName" header={t('Region.Regions Name')} sortable={true} className="wordBreakLine" />
                                        <Column field="Description" header={t('Region.Description')} sortable={true} className="wordBreakLine" />

                                        <Column field="CreatedDate" body={this.formatCreatedDate} header={t('Region.Created Date')} sortable={true} />
                                        <Column field="UpdatedTime" body={this.formatUpdatedDate} header={t('Region.Updated Date')} sortable={true} />
                                        <Column headerClassName="hideheader" body={this.actionColumn} header={t('First_Responder.Action')} />
                                    </DataTable>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <Modal open={this.state.openModal} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('Region.Add Region')}</h2>
                        </div>
                        <div className="forms add-device setting-panel">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                    <form className="form-horizontal modalForm">
                                        {/* <div className="form-group">
                                            <label className="col-sm-3 control-label">
                                                Page Sequence
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="number"
                                                    id="PageSequence"
                                                    name={'PageSequence'}
                                                    value={this.state.newCarouselData.PageSequence}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Region.Regions Name')}</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="RegionName"
                                                    name={'RegionName'}
                                                    value={this.state.newRegionData.RegionName}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Description Text')}</label>
                                            <div className="col-sm-9">
                                                <textarea rows="5" id="Description" name={'Description'} className="form-control1"
                                                    value={this.state.newRegionData.Description} onChange={this.handleInput}></textarea>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-sm-offset-5 col-sm-6">
                                                <p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary general-btn"
                                                        onClick={this.add}
                                                    >
                                                        {t('Alarm Setting.Save')}
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                    </form></div></div></div>
                    </div>
                </Modal>
                <Modal open={this.state.isEdit} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('Region.Edit Region')}</h2>
                        </div>
                    </div>
                    <div className="forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form className="form-horizontal modalForm">
                                    <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('Region.Regions Name')}</label>
                                        <div className="col-sm-9">
                                            <InputWithExtra
                                                type="text"
                                                id="RegionName"
                                                name={'RegionName'}
                                                value={this.state.newRegionData.RegionName}
                                                className="form-control1 FR-edit-details"
                                                onChange={this.handleInput}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('Carousel Setting.Description Text')}</label>
                                        <div className="col-sm-9">
                                            <InputWithExtra type="text" id="Description" name={'Description'} className="form-control1 FR-edit-details"
                                                value={this.state.newRegionData.Description} onChange={this.handleInput} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={this.update}
                                                >
                                                    {t('Alarm Setting.Save')}
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </form></div></div></div>
                </Modal>
                {/* <Editor
          editorState={this.state.editorState}
          onEditorStateChange={this.onEditorStateChange}
        /> */}
            </div>
        )
    }
}
export default withNamespaces()(RegionComponent);